/* ============================================================
 * nv-pdp-gallery.js - galeria da pagina de produto
 * Mobile: indicador do carrossel.
 * Desktop: a rolagem do mouse vai SO para a coluna das fotos secundarias;
 * a pagina inteira (inclusive o cabecalho) fica parada ate a ultima foto
 * secundaria passar. Na volta, ao chegar ao topo da pagina, a coluna
 * volta a receber a rolagem.
 * Tambem traz a foto da variante escolhida para a frente.
 * ============================================================ */
(function () {
  var DESK = '(min-width: 1025px)';
  var TOP_EPS = 2;

  function isDesk() { return window.matchMedia(DESK).matches; }

  function init(g) {
    if (g.dataset.nvInit) return;
    g.dataset.nvInit = '1';
    var track = g.querySelector('.nv-pdp-track');
    var rest = g.querySelector('.nv-pdp-rest');
    var dots = g.querySelector('.nv-pdp-dots');
    if (!track) return;
    var frames = track.querySelectorAll('.nv-pdp-frame');
    if (!rest || !rest.children.length) track.classList.add('nv-pdp-single');

    /* ---------- mobile: barrinhas ---------- */
    if (dots && frames.length > 1) {
      for (var i = 0; i < frames.length; i++) dots.appendChild(document.createElement('span'));
    }
    function active() {
      if (!dots || !dots.children.length) return;
      var w = track.clientWidth || 1;
      var idx = Math.round(track.scrollLeft / w);
      for (var j = 0; j < dots.children.length; j++) dots.children[j].classList.toggle('nv-on', j === idx);
    }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; active(); });
    }, { passive: true });
    active();

    /* ---------- desktop: a coluna das secundarias tem exatamente a altura da foto principal,
       assim a primeira e a ultima secundaria encaixam alinhadas com ela ---------- */
    var pdpTop = g.closest('.productView-top');
    var info = pdpTop ? pdpTop.querySelector('.halo-productView-right') : null;

    function size() {
      if (!rest) return;
      if (!isDesk()) {
        g.style.removeProperty('--nv-pdp-h');
        if (pdpTop) pdpTop.style.removeProperty('--nv-info-h');
        return;
      }
      var main = track.firstElementChild;
      var h = main ? main.getBoundingClientRect().height : 0;
      if (h > 0) g.style.setProperty('--nv-pdp-h', h + 'px');
      /* coluna de informacoes: usa a altura visivel da tela (nunca menor que a foto principal) */
      if (info && pdpTop) {
        var infoTop = info.getBoundingClientRect().top + window.scrollY;
        var ih = Math.max(h, window.innerHeight - infoTop - 16);
        pdpTop.style.setProperty('--nv-info-h', ih + 'px');
      }
    }
    size();
    window.addEventListener('resize', size);
    window.addEventListener('load', size);
    if ('ResizeObserver' in window && track.firstElementChild) new ResizeObserver(size).observe(track.firstElementChild);

    /* ---------- desktop: rolagem vai primeiro para a coluna das secundarias ---------- */
    function atPageTop() { return window.scrollY <= TOP_EPS; }
    function restCanScroll(dy) {
      if (!rest) return false;
      if (dy > 0) return rest.scrollTop + rest.clientHeight < rest.scrollHeight - 1;
      if (dy < 0) return rest.scrollTop > 0;
      return false;
    }
    /* ---------- desktop: cada giro da rodinha troca UMA foto inteira ---------- */
    function items() { return rest ? rest.querySelectorAll('.nv-pdp-frame') : []; }
    function stepSize() {
      var it = items();
      return it.length > 1 ? (it[1].offsetTop - it[0].offsetTop) : (rest ? rest.clientHeight : 1);
    }
    var cur = 0;
    function curIndex() { return cur; }
    /* se a coluna rolar por outro meio, ressincroniza a foto atual quando ela parar */
    var syncT = null;
    if (rest) rest.addEventListener('scroll', function () {
      clearTimeout(syncT);
      syncT = setTimeout(function () { if (!locked) cur = Math.round(rest.scrollTop / (stepSize() || 1)); }, 180);
    }, { passive: true });
    function canPage(dir) {
      var i = curIndex() + dir;
      return i >= 0 && i < items().length;
    }
    function page(dir) {
      var i = curIndex() + dir;
      cur = i;
      var max = rest.scrollHeight - rest.clientHeight;
      rest.scrollTo({ top: Math.max(0, Math.min(i * stepSize(), max)), behavior: 'smooth' });
    }

    /* trava ate o gesto acabar: a inercia do trackpad/rodinha nao pula varias fotos de uma vez */
    var locked = false, lockStart = 0, idleT = null;
    function poke() {
      clearTimeout(idleT);
      idleT = setTimeout(function () { locked = false; }, 220);
    }
    function lock() { locked = true; lockStart = Date.now(); poke(); }

    /* coluna de informacoes: rola continua (como a pagina), depois que as fotos acabaram */
    function infoCan(dir) {
      if (!info) return false;
      if (dir > 0) return info.scrollTop + info.clientHeight < info.scrollHeight - 1;
      return info.scrollTop > 0;
    }
    function scrollInfo(dy) {
      var max = info.scrollHeight - info.clientHeight;
      var n = info.scrollTop + dy;
      if (n >= max) {
        info.scrollTop = max;
        /* a sobra do mesmo gesto ja comeca a rolar a pagina */
        if (n > max) window.scrollBy(0, n - max);
        return true;
      }
      if (n <= 0) { info.scrollTop = 0; return true; }
      info.scrollTop = n;
      return false;
    }

    window.addEventListener('wheel', function (e) {
      if (!rest || !isDesk() || e.ctrlKey) return;
      if (window.getComputedStyle(rest).display === 'contents') return;
      if (g.classList.contains('nv-pdp-auto')) return;
      var dy = e.deltaY;
      if (e.deltaMode === 1) dy *= 16;
      else if (e.deltaMode === 2) dy *= window.innerHeight;
      if (!dy) return;
      /* so enquanto a pagina esta no topo: depois que ela comecou a rolar, segue normal */
      if (!atPageTop()) return;
      /* nao sequestra a rolagem de caixas internas (listas, popups, carrinho lateral) */
      var t = e.target;
      if (t && t.closest && t.closest('.halo-sidebar, .halo-popup, [role="dialog"], .halo-cart-sidebar, .menu-drawer')) return;

      if (locked) {
        if (Date.now() - lockStart < 1100) { e.preventDefault(); poke(); return; }
        locked = false;
      }

      if (dy > 0) {
        /* descendo: 1) fotos do meio, uma por vez  2) coluna de informacoes  3) pagina */
        if (canPage(1)) { e.preventDefault(); page(1); lock(); return; }
        if (infoCan(1)) { e.preventDefault(); scrollInfo(dy); return; }
        return;
      }
      /* subindo: 1) coluna de informacoes volta ao topo  2) fotos do meio, uma por vez */
      if (infoCan(-1)) {
        e.preventDefault();
        if (scrollInfo(dy)) lock();
        return;
      }
      if (canPage(-1)) { e.preventDefault(); page(-1); lock(); return; }
    }, { passive: false });

    /* teclado (setas, page down, espaco): uma foto por toque, com a pagina no topo */
    window.addEventListener('keydown', function (e) {
      if (!rest || !isDesk() || !atPageTop()) return;
      if (window.getComputedStyle(rest).display === 'contents') return;
      if (g.classList.contains('nv-pdp-auto')) return;
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT|BUTTON/.test(tag)) return;
      var dir = 0;
      if (e.key === 'ArrowDown' || e.key === 'PageDown' || (e.key === ' ' && !e.shiftKey)) dir = 1;
      else if (e.key === 'ArrowUp' || e.key === 'PageUp' || (e.key === ' ' && e.shiftKey)) dir = -1;
      if (!dir) return;
      if (dir > 0) {
        if (canPage(1)) { e.preventDefault(); page(1); return; }
        if (infoCan(1)) { e.preventDefault(); info.scrollBy({ top: 120, behavior: 'smooth' }); }
        return;
      }
      if (infoCan(-1)) { e.preventDefault(); info.scrollBy({ top: -120, behavior: 'smooth' }); return; }
      if (canPage(-1)) { e.preventDefault(); page(-1); }
    });

    /* ---------- troca de variante: foto da variante vira a principal ---------- */
    var map = {};
    try {
      var node = g.querySelector('[data-nv-variant-media]');
      if (node) map = JSON.parse(node.textContent);
    } catch (e) {}

    function goTo(mediaId) {
      if (!mediaId) return;
      var f = track.querySelector('[data-media-id="' + mediaId + '"]');
      if (!f) return;
      if (isDesk()) {
        var main = track.firstElementChild;
        if (!rest || f === main) return;
        rest.insertBefore(main, f);
        track.insertBefore(f, rest);
        rest.scrollTop = 0;
        cur = 0;
      } else {
        var first = track.querySelector('.nv-pdp-frame');
        track.scrollTo({ left: f.offsetLeft - first.offsetLeft, behavior: 'smooth' });
      }
    }

    var form = document.querySelector('.productView-details form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    var input = form ? form.querySelector('[name="id"]') : null;
    var last = input ? input.value : null;
    function check() {
      if (!input) return;
      if (input.value !== last) {
        last = input.value;
        goTo(map[last]);
      }
    }
    document.addEventListener('change', function () { setTimeout(check, 60); });
    document.addEventListener('click', function () { setTimeout(check, 120); });
  }

    function start() {
    var list = document.querySelectorAll('[data-nv-pdp]');
    for (var i = 0; i < list.length; i++) init(list[i]);
    revealTabs();
  }

  /* abas da coluna de informacoes: ao abrir uma aba (ex.: Modo de uso), a coluna rola
     sozinha ate ela, e a pagina nao pula para fora da posicao em que estava */
  function revealTabs() {
    var info = document.querySelector('.productView-top.nv-pdp-on .halo-productView-right');
    if (!info) return;
    info.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('.productView-tab .toggleLink');
      if (!link) return;
      var tab = link.closest('.tab-content');
      var wasTop = window.scrollY <= 2;
      var desk = window.matchMedia(DESK).matches;
      function fix() {
        if (desk && wasTop && window.scrollY > 2) window.scrollTo(0, 0);
        if (!tab) return;
        var content = tab.querySelector('.toggle-content');
        var open = content && content.offsetHeight > 0;
        if (!open) return;
        if (desk && info.scrollHeight > info.clientHeight) {
          var ir = info.getBoundingClientRect();
          var tr = tab.getBoundingClientRect();
          if (tr.bottom > ir.bottom || tr.top < ir.top) {
            info.scrollBy({ top: tr.top - ir.top - 16, behavior: 'smooth' });
          }
        } else if (!desk) {
          var r = tab.getBoundingClientRect();
          if (r.bottom > window.innerHeight) window.scrollBy({ top: r.top - 90, behavior: 'smooth' });
        }
      }
      setTimeout(fix, 60);
      setTimeout(fix, 450);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
